var map = {
	"./Path.png": "e675",
	"./accepted_quotes.png": "3c9b",
	"./delivered.png": "0680",
	"./expired_quotes.png": "1f7b",
	"./new_quotes.png": "3851",
	"./pdf-icon.png": "0056",
	"./pending_quotes.png": "253c",
	"./rejected_quotes.png": "6034",
	"./sales.png": "e926",
	"./scheduled.png": "07db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";